module.exports = __webpack_public_path__ + "static/media/battles-current-info.2bc3349f.png";